export default [{
    path: '/qa',
    meta: {
        title: '',
        track: {
            evt: 'BRAND_QA',
            label: ''
        }
    },
    component: resolve => require.ensure([], () => resolve(require('../pages/qa/index.vue')), 'qa'),
    children: [{
        path: 'repayment',
        meta: {
            title: '',
            track: {
                evt: 'BRAND_QA_REPAYMENT',
                label: ''
            }
        },
        component: resolve => require.ensure([], () => resolve(require('../pages/qa/repayment.vue')), 'qa-repayment'),
    }, {
        path: 'quota',
        meta: {
            title: '',
            track: {
                evt: 'BRAND_QA_QUOTA',
                label: ''
            }
        },
        component: resolve => require.ensure([], () => resolve(require('../pages/qa/quota.vue')), 'qa-quota'),
    }, {
        path: 'cash',
        meta: {
            title: '',
            track: {
                evt: 'BRAND_QA_LOAN',
                label: ''
            }
        },
        component: resolve => require.ensure([], () => resolve(require('../pages/qa/loan.vue')), 'qa-loan'),
    }]
}];



// WEBPACK FOOTER //
// ./src/routes/qa.js